const apiUrl = 'https://apis.thesleepcompany.in/utilities/customer-reviews';
const itemsPerPage = 3;
let currentPage = 1;
let totalPages = 1;
let totalReviews = 0;
let isLoading = false;
let isArrowInitialized = false;
let loadedReviews = 0;

let prevIsMobile = window.innerWidth <= 768;
const leftBtn = document.getElementById('dev_prv-review-all-img-button_left'); 
const rightBtn = document.getElementById('dev_prv-review-all-img-button_right'); 
let thumbnailContainer = document.querySelector('.prv-review-thumbnails');
const sliderContainer = document.querySelector('.prv-review-all-images-slider');
let viewAllBtn = document.getElementById('dev_prv-thumbnail-view-all');
const reviewsContainer = document.getElementById('reviews-container');
const paginationContainer = document.getElementById('pagination-container');
const loadMoreBtn = document.getElementById('load-more-btn');

let sliderParent;

const thumbnailapiUrl = `https://apis.thesleepcompany.in/utilities/customer-reviews/images?itemsPerPage=7&productId=${currentProductId}`;

let sliderCurrentPage = 1;
let isLoadingMoreSliderReviews = false;
let sliderReviews = [];
function fetchInitialSliderReviews() {
  fetch(thumbnailapiUrl)
    .then(response => response.json())
    .then(data => {
      if (data && data.data && data.data.length > 0) {
        sliderReviews = [...data.data];
        appendThumbnails(data.data);
        appendSliderReviews(data.data);
        setupViewAllButton();
        setupSliderScrollListener();
      } else {
        console.error('No review data found');
      }
    })
    .catch(error => {
      console.error('Error fetching review data:', error);
    });
}

function fetchMoreSliderReviews() {
  if (isLoadingMoreSliderReviews) return;

  isLoadingMoreSliderReviews = true;
  sliderCurrentPage++;

  fetch(`${thumbnailapiUrl}&pageNumber=${sliderCurrentPage}`)
    .then(response => response.json())
    .then(data => {
      if (data && data.data && data.data.length > 0) {
        sliderReviews = [...sliderReviews, ...data.data];
        appendSliderReviews(data.data, false);
      }
    })
    .catch(error => {
      console.error('Error fetching more slider reviews:', error);
    })
    .finally(() => {
      isLoadingMoreSliderReviews = false;
    });
}

function appendSliderReviews(reviews, clearContainer = true) {
  if (clearContainer) {
    sliderContainer.innerHTML = '';
  }

  reviews.forEach(review => {
    if (review.productImages && review.productImages.length > 0) {
      const slide = document.createElement('div');
      slide.className = 'prv-single-review';

      const reviewInfo = document.createElement('div');
      reviewInfo.className = 'prv-review';

      const reviewHeader = document.createElement('div');
      reviewHeader.className = 'prv-review-header';

      const ratingDiv = document.createElement('div');
      ratingDiv.className = 'prv-review-rating';
      ratingDiv.innerHTML = `<span class="prv-rating-value">${review.rating}</span><span class="prv-rating-icon">★</span>`;

      const reviewerDiv = document.createElement('div');
      reviewerDiv.className = 'prv-reviewer';
      reviewerDiv.innerHTML = `${review.customerName} <span class="prv-reviewr-date"></span>`;

      reviewHeader.appendChild(ratingDiv);
      reviewHeader.appendChild(reviewerDiv);

      const reviewTitle = document.createElement('h4');
      reviewTitle.className = 'prv-review-title';
      reviewTitle.textContent = review.title;

      const reviewContent = document.createElement('p');
      reviewContent.className = 'prv-review-content';
      reviewContent.textContent = review.review;

      reviewInfo.appendChild(reviewHeader);
      reviewInfo.appendChild(reviewTitle);
      reviewInfo.appendChild(reviewContent);

      const mainImg = document.createElement('img');
      mainImg.className = 'prv-review-all-image';
      mainImg.src = review.productImages[0];
      mainImg.alt = '';
      mainImg.loading = 'lazy';

      const allImages = document.createElement('div');
      allImages.className = 'prv-review-other-images hide-mbl';

      review.productImages.forEach(imgSrc => {
        const imgThumb = document.createElement('img');
        imgThumb.className = 'prv-review-thumb-image';
        imgThumb.src = imgSrc;
        imgThumb.alt = '';
        imgThumb.loading = 'lazy';

        imgThumb.addEventListener('click', () => {
          mainImg.src = imgSrc;
        });

        allImages.appendChild(imgThumb);
      });

      slide.appendChild(reviewInfo);
      slide.appendChild(mainImg);
      reviewInfo.appendChild(allImages);

      sliderContainer.appendChild(slide);
    }
  });
}

function appendThumbnails(reviews) {
  const existingThumbnails = thumbnailContainer.querySelectorAll('.prv-thumbnail:not(#dev_prv-thumbnail-view-all)');
  existingThumbnails.forEach(thumb => thumb.remove());

  reviews.forEach((review, index) => {
    if (review.productImages && review.productImages.length > 0) {
      const thumbnail = document.createElement('div');
      thumbnail.className = 'prv-thumbnail';

      const img = document.createElement('img');
      img.src = review.productImages[0];
      img.alt = 'Review thumbnail';
      img.loading = 'lazy';
      img.width = '100%';
      img.height = 'auto';

      thumbnail.appendChild(img);

      if (thumbnail.classList.contains('prv-view-all')) {
        const viewAllSpan = document.createElement('span');
        viewAllSpan.textContent = 'View All';

        const overlayDiv = document.createElement('div');
        overlayDiv.className = 'prv-thumbnail-overlay';

        thumbnail.appendChild(viewAllSpan);
        thumbnail.appendChild(overlayDiv);
      }

      thumbnailContainer.insertBefore(thumbnail, viewAllBtn);
    }
  });
}

function setupSliderScrollListener() {
  const allreviewsslider = document.querySelector('#dev_show-allimageslider .prv-review-all-images-slider');

  allreviewsslider.addEventListener('scroll', function() {
    if (isLoadingMoreSliderReviews) return;

    const sliderWidth = allreviewsslider.offsetWidth;
    const scrollPosition = allreviewsslider.scrollLeft;
    const currentSlideIndex = Math.floor(scrollPosition / sliderWidth);
    const slides = allreviewsslider.querySelectorAll('.prv-single-review');

    if (currentSlideIndex >= slides.length - 2) {
      fetchMoreSliderReviews();
    }
  });
}

function appendThumbnails(reviews) {

  thumbnailContainer = document.querySelector('.prv-review-thumbnails');

  thumbnailContainer.innerHTML = '';

  const maxRegularThumbnails = prevIsMobile ? 2 : 6; 
  const totalToShow = Math.min(maxRegularThumbnails, reviews.length);

  for (let i = 0; i < totalToShow; i++) {
    const review = reviews[i];
    if (review.productImages && review.productImages.length > 0) {
      const thumbnail = document.createElement('div');
      thumbnail.className = 'prv-thumbnail';
      thumbnail.dataset.reviewIndex = i; 

      const img = document.createElement('img');
      img.src = review.productImages[0];
      img.alt = 'Review thumbnail';
      img.loading = 'lazy';
      img.width = '100%';
      img.height = 'auto';

      thumbnail.appendChild(img);
      thumbnailContainer.appendChild(thumbnail);

      thumbnail.addEventListener('click', function() {
        openReviewInSlider(i);
      });
    } else {
      thumbnailContainer.style.display = 'none';
      return;
    }
  }

  if (reviews.length > totalToShow) {
    const viewAllThumbnail = document.createElement('div');
    viewAllThumbnail.className = 'prv-thumbnail prv-view-all';
    viewAllThumbnail.id = 'dev_prv-thumbnail-view-all';

    const img = document.createElement('img');
    if (totalToShow < reviews.length && reviews[totalToShow].productImages && reviews[totalToShow].productImages.length > 0) {
      img.src = reviews[totalToShow].productImages[0];
    } else if (reviews[0].productImages && reviews[0].productImages.length > 0) {

      img.src = reviews[0].productImages[0];
    }
    img.alt = 'View all reviews';
    img.loading = 'lazy';
    img.width = '100%';
    img.height = 'auto';

    const viewAllSpan = document.createElement('span');
    viewAllSpan.textContent = 'View All';

    const overlayDiv = document.createElement('div');
    overlayDiv.className = 'prv-thumbnail-overlay';

    viewAllThumbnail.appendChild(img);
    viewAllThumbnail.appendChild(viewAllSpan);
    viewAllThumbnail.appendChild(overlayDiv);

    thumbnailContainer.appendChild(viewAllThumbnail);
  }
}

function openReviewInSlider(index) {
  sliderParent = document.getElementById('dev_show-allimageslider');
  sliderParent.style.display = 'flex';

  const allreviewsslider = document.querySelector('#dev_show-allimageslider .prv-review-all-images-slider');
  const slideAmount = allreviewsslider.offsetWidth;

  if(!isArrowInitialized){
    leftBtn.addEventListener('click', () => {
      allreviewsslider.scrollBy({ left: -slideAmount, behavior: prevIsMobile ? 'smooth' : 'auto' });
    });

    rightBtn.addEventListener('click', () => {
      allreviewsslider.scrollBy({ left: slideAmount, behavior: prevIsMobile ? 'smooth' : 'auto' });

      setTimeout(() => {
        const scrollPosition = allreviewsslider.scrollLeft;
        const currentSlideIndex = Math.floor(scrollPosition / slideAmount);
        const slides = allreviewsslider.querySelectorAll('.prv-single-review');

        if (currentSlideIndex >= slides.length - 2) {
          fetchMoreSliderReviews();
        }
      }, 300);
    });
    isArrowInitialized = true;
  }

  const reviewElements = allreviewsslider.querySelectorAll('.prv-single-review');
  if (index < reviewElements.length) {
    allreviewsslider.scrollTo({
      left: index * slideAmount,
      behavior: 'auto'
    });
  }
}

function setupViewAllButton() {
  viewAllBtn = document.getElementById('dev_prv-thumbnail-view-all');
  viewAllBtn.addEventListener('click', function() {
    openReviewInSlider(0);
    gaEvent('view_all_img', ['', '', '', '', '', ''], false);
  });
}

function addClickHandlersToExistingThumbnails() {
  const existingThumbnails = document.querySelectorAll('.prv-thumbnail:not(#dev_prv-thumbnail-view-all)');
  existingThumbnails.forEach((thumbnail, index) => {
    thumbnail.dataset.reviewIndex = index;
    thumbnail.addEventListener('click', function() {
      openReviewInSlider(index);
    });
  });
}

addClickHandlersToExistingThumbnails();

function formatDate(dateString) {
    if (!dateString) return '';
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    const date = new Date();
    return date.toLocaleDateString('en-US', options);
}

function generateStars(rating) {
    return `<span class="prv-rating-value">${rating}</span><span class="prv-rating-icon">★</span>`;
}

function createReviewElement(review) {
    console.log("review ==> ", review);
    const reviewElement = document.createElement('div');
    reviewElement.className = 'prv-review';
    reviewElement.innerHTML = `
        <div class="prv-review-header">
            <div class="prv-review-rating">
                ${generateStars(review.rating)}
            </div>
            <div class="prv-reviewer">${review.customerName} <span class="prv-reviewr-date">${formatDate()}</span></div>
        </div>
        <div class="prv-review-title">${review.title}</div>
        <p class="prv-review-content">${review.review}</p>
    `;
    return reviewElement;
}

function loadReviews(page, replace = true) {
  writeDummyRatings();
    if (isLoading) return;
    isLoading = true;

    if (replace) {

    } else {
        const loadingIndicator = document.createElement('div');
        loadingIndicator.className = 'prv-loading';
        loadingIndicator.textContent = 'Loading more reviews...';
        reviewsContainer.appendChild(loadingIndicator);
    }

    fetch(`${apiUrl}?pageNumber=${page}&itemsPerPage=${itemsPerPage}&productId=${currentProductId}`)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(responseData => {
            let data = responseData.data || [];

            const loadingElements = document.querySelectorAll('.prv-loading');
            loadingElements.forEach(el => el.remove());

            if (data.length === 0) {
                if (replace || loadedReviews === 0) {
                    reviewsContainer.innerHTML = '<div class="prv-no-reviews">No reviews found</div>';
                }
                return;
            }

            if (responseData.pageNumber !== undefined) {
                currentPage = responseData.pageNumber;
            }

            if (responseData.reviewCount && responseData.reviewCount.filteredReviewCount) {
                totalReviews = responseData.reviewCount.filteredReviewCount;
                totalPages = Math.ceil(totalReviews / itemsPerPage);
            } else {
                totalPages = 9;
                totalReviews = totalPages * itemsPerPage;
            }

            if (responseData.averageRating !== undefined) {
                updateReviewSummary(responseData);
            }

            if (replace) {
                reviewsContainer.innerHTML = '';
                loadedReviews = 0;
            }

            data.forEach(review => {
                reviewsContainer.appendChild(createReviewElement(review));
                loadedReviews++;
            });

            updatePagination(totalPages);
            updateLoadMoreButton();
        })
        .catch(error => {
            console.error('Error fetching reviews:', error);

            const loadingElements = document.querySelectorAll('.prv-loading');
            loadingElements.forEach(el => el.remove());

            if (replace || loadedReviews === 0) {
                reviewsContainer.innerHTML = '<div class="prv-error">Error loading reviews. Please try again later.</div>';
            } else {
                const errorMsg = document.createElement('div');
                errorMsg.className = 'prv-error';
                errorMsg.textContent = 'Error loading more reviews. Please try again.';
                reviewsContainer.appendChild(errorMsg);
            }
        })
        .finally(() => {
            isLoading = false;
        });
}

function updateReviewSummary(responseData) {
    if (!responseData || responseData.averageRating === undefined) return;

    const averageRating = Number(responseData.averageRating).toFixed(1);

    const ratingScoreElement = document.querySelector('.prv-rating-score');
    const ratingScoreElementTSC = document.querySelector('.dev_prv-category-score');
    if (ratingScoreElement) {
        ratingScoreElement.innerHTML = `${averageRating} <span class="prv-star">★</span>`;
        ratingScoreElementTSC.innerHTML = `${averageRating}`;
    }

    const reviewCountElements = document.querySelectorAll('.dev_mattress-pdp-review-count');
    if (responseData.reviewCount) {
        reviewCountElements.forEach(element => {
            element.innerHTML = `${averageRating} <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.6565 6.48163L10.8377 8.94163L11.6821 12.6041C11.7268 12.7956 11.714 12.996 11.6454 13.1802C11.5768 13.3645 11.4555 13.5245 11.2965 13.6401C11.1375 13.7557 10.9479 13.822 10.7515 13.8305C10.555 13.839 10.3605 13.7894 10.1921 13.6879L6.99771 11.7504L3.81021 13.6879C3.64182 13.7894 3.44724 13.839 3.25082 13.8305C3.05439 13.822 2.86483 13.7557 2.70583 13.6401C2.54683 13.5245 2.42545 13.3645 2.35686 13.1802C2.28828 12.996 2.27553 12.7956 2.32021 12.6041L3.16333 8.94538L0.343959 6.48163C0.19484 6.35302 0.0870106 6.18325 0.0339942 5.9936C-0.0190223 5.80395 -0.014866 5.60287 0.0459417 5.41558C0.106749 5.22828 0.221502 5.06311 0.375808 4.94077C0.530115 4.81843 0.717106 4.74437 0.913334 4.72788L4.62958 4.40601L6.08021 0.946008C6.15596 0.764456 6.28374 0.609375 6.44745 0.500294C6.61116 0.391213 6.80349 0.333008 7.00021 0.333008C7.19693 0.333008 7.38926 0.391213 7.55297 0.500294C7.71668 0.609375 7.84446 0.764456 7.92021 0.946008L9.37521 4.40601L13.0902 4.72788C13.2864 4.74437 13.4734 4.81843 13.6277 4.94077C13.782 5.06311 13.8968 5.22828 13.9576 5.41558C14.0184 5.60287 14.0226 5.80395 13.9695 5.9936C13.9165 6.18325 13.8087 6.35302 13.6596 6.48163H13.6565Z" fill="#2E7D32"/></svg> | ${responseData.reviewCount.filteredReviewCount} reviews`;
            var parentWrapper = element.closest('.mattress-pdp-product-reviews-wrapper');
            if (parentWrapper) {
                parentWrapper.classList.add('data-added'); 
            }
        });
    }

    if (responseData.reviewCount) {
        updateRatingBars(responseData.reviewCount);
    }
}


function getDummyRatings() {
  if (window.__ratingsDataPromise) return window.__ratingsDataPromise;

  var SHEET_ID = '1zc4cPyEhtNrBgbW-lFOy1On_MwK_hllCLTnMBFtWCJI';
  var GID = 0;
  var url = 'https://docs.google.com/spreadsheets/d/' + SHEET_ID + '/gviz/tq?tqx=out:json&gid=' + GID;

  window.__ratingsDataPromise = fetch(url)
    .then(function(res){ return res.text(); })
    .then(function(txt){
      var start = txt.indexOf('{'), end = txt.lastIndexOf('}');
      if (start === -1 || end === -1) throw new Error('GViz parse failed');
      var json = JSON.parse(txt.slice(start, end + 1));
      var rows = (json.table && json.table.rows) || [];
      var out  = {};

      for (var i = 0; i < rows.length; i++) {
        var c = rows[i].c || [];
        var productId = (c[0] && c[0].v != null ? String(c[0].v) : '').trim(); 
        var name      = (c[1] && c[1].v != null ? String(c[1].v) : '').trim(); 
        var avg       = Number(c[2] && c[2].v);                                 
        var total     = Number(c[6] && c[6].v);                                 
        if (!productId || !isFinite(avg) || !isFinite(total)) continue;

        var five   = Number(c[13] && c[13].v) || 0; // N: 5★
        var four   = Number(c[14] && c[14].v) || 0; // O: 4★
        var three  = Number(c[15] && c[15].v) || 0; // P: 3★
        var two    = Number(c[16] && c[16].v) || 0; // Q: 2★
        var one    = Number(c[17] && c[17].v) || 0; // R: 1★

        out[productId] = {
          name: name,
          avg: avg,
          total: total,
          ratings: { five: five, four: four, three: three, two: two, one: one }
        };
      }
      window.__ratingsData = out;
      return out;
    })
    .catch(function(err){
      console.error('getDummyRatings error:', err);
      window.__ratingsDataPromise = null;
      return {};
    });

  return window.__ratingsDataPromise;
}

function writeDummyRatings(data) {

  setTimeout(() => {

    var out = data || window.__ratingsData;
    if (!out) return;
    var p = out[currentProductId];
    if (!p) return;

    var avg = Number(p.avg).toFixed(1);

    document.querySelectorAll('.dev_mattress-pdp-review-count')?.forEach(function(el){

      el.innerHTML = `${avg} <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.6565 6.48163L10.8377 8.94163L11.6821 12.6041C11.7268 12.7956 11.714 12.996 11.6454 13.1802C11.5768 13.3645 11.4555 13.5245 11.2965 13.6401C11.1375 13.7557 10.9479 13.822 10.7515 13.8305C10.555 13.839 10.3605 13.7894 10.1921 13.6879L6.99771 11.7504L3.81021 13.6879C3.64182 13.7894 3.44724 13.839 3.25082 13.8305C3.05439 13.822 2.86483 13.7557 2.70583 13.6401C2.54683 13.5245 2.42545 13.3645 2.35686 13.1802C2.28828 12.996 2.27553 12.7956 2.32021 12.6041L3.16333 8.94538L0.343959 6.48163C0.19484 6.35302 0.0870106 6.18325 0.0339942 5.9936C-0.0190223 5.80395 -0.014866 5.60287 0.0459417 5.41558C0.106749 5.22828 0.221502 5.06311 0.375808 4.94077C0.530115 4.81843 0.717106 4.74437 0.913334 4.72788L4.62958 4.40601L6.08021 0.946008C6.15596 0.764456 6.28374 0.609375 6.44745 0.500294C6.61116 0.391213 6.80349 0.333008 7.00021 0.333008C7.19693 0.333008 7.38926 0.391213 7.55297 0.500294C7.71668 0.609375 7.84446 0.764456 7.92021 0.946008L9.37521 4.40601L13.0902 4.72788C13.2864 4.74437 13.4734 4.81843 13.6277 4.94077C13.782 5.06311 13.8968 5.22828 13.9576 5.41558C14.0184 5.60287 14.0226 5.80395 13.9695 5.9936C13.9165 6.18325 13.8087 6.35302 13.6596 6.48163H13.6565Z" fill="#2E7D32"/></svg> | ${p.total} reviews`;
            var parentWrapper = el.closest('.mattress-pdp-product-reviews-wrapper');
            if (parentWrapper) {
                parentWrapper.classList.add('data-added'); 
            }

    });


    var score = document.querySelector('.prv-rating-score');
    var score2 = document.querySelector('.dev_prv-category-score');
    if (score)  score.innerHTML = avg + ' <span class="prv-star">★</span>';
    if (score2) score2.textContent = avg;

    updateRatingBars({ filteredReviewCount: p.total, 1: p.ratings.one, 2: p.ratings.two, 3: p.ratings.three, 4: p.ratings.four, 5: p.ratings.five });
  }, 2000);
}

getDummyRatings().then(function(data){
  writeDummyRatings(data);
});

function updateRatingBars(reviewCount) {
    const totalCount = reviewCount.filteredReviewCount || 0;

    for (let i = 1; i <= 5; i++) {
        const count = reviewCount[i] || 0;
        const percent = totalCount ? ((count / totalCount) * 100).toFixed(0) : 0;

        const barSelector = `.prv-rating-bar-row:nth-child(${6 - i}) .prv-rating-bar`;
        const bar = document.querySelector(barSelector);
        if (bar) {
            bar.style.width = `${percent}%`;
        }

        const countElement = document.querySelector(`.prv-rating-count-update-star${i}`);
        if (countElement) {
            countElement.textContent = count;
        }

        const rowCountElement = document.querySelector(`.prv-rating-bar-row:nth-child(${6 - i}) .prv-rating-count`);
        if (rowCountElement && !rowCountElement.classList.contains(`prv-rating-count-update-star${i}`)) {
            rowCountElement.textContent = count;
        }
    }

    const totalCountElement = document.querySelector('.prv-total-review-count');
    if (totalCountElement && totalCount) {
        totalCountElement.textContent = totalCount;
    }
}

function loadMoreReviews() {
    if (isLoading || currentPage >= totalPages) return;

    currentPage++;
    loadReviews(currentPage, false);
}

function updateLoadMoreButton() {
    if (loadedReviews >= totalReviews || currentPage >= totalPages) {
        loadMoreBtn.classList.add('prv-disabled');
        loadMoreBtn.style.display = 'none';
    } else {
        loadMoreBtn.classList.remove('prv-disabled');
        loadMoreBtn.textContent = 'Load more reviews';
    }
}

function updatePagination(total) {
    totalPages = total;
    paginationContainer.innerHTML = '';

    const prevButton = document.createElement('div');
    prevButton.className = `prv-page-nav prv-prev ${currentPage === 1 ? 'prv-disabled' : ''}`;
    prevButton.innerHTML = '<span>&#8249;</span>';
    prevButton.addEventListener('click', function(e) {
        e.preventDefault();
        if (currentPage > 1) {
            currentPage--;
            loadReviews(currentPage, true);

            reviewsContainer.scrollIntoView({ behavior: 'smooth' });
        }
    });
    paginationContainer.appendChild(prevButton);

    const maxVisiblePages = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
        const pageLink = document.createElement('div');
        pageLink.className = `prv-page-number ${i === currentPage ? 'prv-active' : ''}`;
        pageLink.textContent = i;
        pageLink.addEventListener('click', function(e) {
            e.preventDefault();
            currentPage = i;
            loadReviews(currentPage, true);

        });
        paginationContainer.appendChild(pageLink);
    }

    if (endPage < totalPages) {
        const ellipsis = document.createElement('span');
        ellipsis.className = 'prv-ellipsis';
        ellipsis.textContent = '...';
        paginationContainer.appendChild(ellipsis);

        const lastPage = document.createElement('div');
        lastPage.className = 'prv-page-number';
        lastPage.textContent = totalPages;
        lastPage.addEventListener('click', function(e) {
            e.preventDefault();
            currentPage = totalPages;
            loadReviews(currentPage, true);
            reviewsContainer.scrollIntoView({ behavior: 'smooth' });
        });
        paginationContainer.appendChild(lastPage);
    }

    const nextButton = document.createElement('div');
    nextButton.className = `prv-page-nav prv-next ${currentPage === totalPages ? 'prv-disabled' : ''}`;
    nextButton.innerHTML = '<span>&#8250;</span>';
    nextButton.addEventListener('click', function(e) {
        e.preventDefault();
        if (currentPage < totalPages) {
            currentPage++;
            loadReviews(currentPage, true);
            reviewsContainer.scrollIntoView({ behavior: 'smooth' });
        }
    });
    paginationContainer.appendChild(nextButton);
}

loadReviews(currentPage, true);

if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', function() {
        if (!loadMoreBtn.classList.contains('prv-disabled')) {
            loadMoreReviews();
            gaEvent('load_more_reviews', ['','','','','',''], false);
        }
    });
}

window.addEventListener('resize', function() {
    const isMobile = window.innerWidth <= 768;

    if (isMobile !== prevIsMobile) {
        prevIsMobile = isMobile;

        currentPage = 1;
        loadedReviews = 0;
        loadReviews(currentPage, true);
    }
});

document.getElementById('dev_close-review-all-popup').addEventListener('click', function() {
    sliderParent.style.display = 'none';
});

document.getElementById("dev_show-allimageslider").addEventListener("click", function (e) {
  const clickedInsideSlider = e.target.closest("#dev_svg-show-allimge-extra-wrap");
  if (!clickedInsideSlider) {
    this.style.display = "none";
  }
});

fetchInitialSliderReviews();